import Color from "./color";
import Model from "./model";
import { ColorStop as ApiColorStop } from "../api/model/snapshots/layers/Gradient";
import { PartialOnly } from "../utils/UtilityTypes";
import ColorDefinition from "./ColorDefinition";
import { VariableReference } from "../api/model/variables/Variables";

export default class ColorStop extends Model {
    #color: Color;
    #position: number;
    #variableReferences: VariableReference[] | undefined;

    constructor({
        color,
        position,
        variableReferences
    }: ApiColorStop) {
        super();

        this.#color = new Color(color);
        this.#position = position;
        this.#variableReferences = variableReferences;
    }

    get color(): Color {
        return this.#color;
    }

    set color(value: PartialOnly<ColorDefinition, "a">) {
        this.#color = new Color(value);
    }

    get position(): number {
        return this.#position;
    }

    set position(value: number) {
        if (value < 0 || value > 1) {
            throw new RangeError(`Invalid position value: '${value}'. Valid range: [0, 1]`);
        }

        this.#position = value;
    }

    get variableReferences() : VariableReference[] | undefined {
        return this.#variableReferences;
    }

    set variableReferences(variableReferences: VariableReference[] | undefined) {
        this.#variableReferences = variableReferences;
    }

    override toObject(): ApiColorStop {
        return {
            color: this.color.toObject(),
            position: this.position,
            variableReferences: this.variableReferences
        };
    }
}
